import Img, { GatsbyImageFluidProps } from 'gatsby-image'
import React, { FunctionComponent } from 'react'
import { imageAnimation } from './animations'
import { motion } from 'framer-motion'
import styled from 'styled-components'
import useImageData from '../../../hooks/use-image-data/useImageData'
import { useInView } from 'react-intersection-observer'

export interface ImageProps {
  className?: string
  url: string
}

const Image: FunctionComponent<ImageProps> = ({ className, url }) => {
  const image = useImageData(url)

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  if (!image) {
    return null
  }

  return (
    <motion.div
      animate={inView ? ['opacityIn', 'transformIn'] : 'initial'}
      className={className}
      ref={ref}
      variants={imageAnimation}
    >
      <StyledImage fluid={image.fluid} />
    </motion.div>
  )
}

const StyledImage = styled(Img)<GatsbyImageFluidProps>`
  display: block;
  width: 100%;
`

export default Image
